(() => {
	const updateSlideAria = (swiper) => {
		swiper.slides.forEach((slide, index) => {
			const isActive = index === swiper.activeIndex;
			slide.setAttribute("aria-hidden", isActive ? "false" : "true");
			slide.setAttribute("tabindex", isActive ? "0" : "-1");
		});
	};

	const bindPauseButton = (slideshow, swiper) => {
		const pauseButton = slideshow.querySelector("[data-slideshow-pause]");
		if (!pauseButton || !swiper.autoplay) return;

		const pauseIcon = pauseButton.querySelector(".slideshow__pause-icon--pause");
		const playIcon = pauseButton.querySelector(".slideshow__pause-icon--play");

		const setPaused = (paused) => {
			pauseButton.setAttribute("aria-pressed", paused ? "true" : "false");
			if (pauseIcon) pauseIcon.classList.toggle("hidden", paused);
			if (playIcon) playIcon.classList.toggle("hidden", !paused);
		};

		pauseButton.addEventListener("click", () => {
			if (swiper.autoplay.running) {
				swiper.autoplay.stop();
				setPaused(true);
			} else {
				swiper.autoplay.start();
				setPaused(false);
			}
		});
	};

	const initSliders = () => {
		const slideshows = document.querySelectorAll(".slideshow__swiper");
		slideshows.forEach((slideshow) => {
			if (typeof Swiper === "undefined") return;
			if (slideshow.swiper && !slideshow.swiper.destroyed) {
				slideshow.swiper.destroy(true, true);
			}

			const autoplayEnabled =
				slideshow.getAttribute("data-autoplay") === "true";
			const firstSlide = slideshow.querySelector(".swiper-slide");
			const delay = firstSlide
				? parseInt(firstSlide.getAttribute("data-swiper-autoplay") || "5000", 10)
				: 5000;

			const slideshowSwiper = new Swiper(slideshow, {
				navigation: {
					nextEl: slideshow.querySelector(".swiper-button-next"),
					prevEl: slideshow.querySelector(".swiper-button-prev"),
				},
				autoplay: autoplayEnabled
					? {
							delay,
							disableOnInteraction: false,
							pauseOnMouseEnter: true,
						}
					: false,
				loop: true,
				autoHeight: false,
				simulateTouch: true,
				allowTouchMove: true,
				watchSlidesProgress: true,
				preventInteractionOnTransition: true,
				mousewheel: {
					forceToAxis: true,
				},
				on: {
					init(swiper) {
						updateSlideAria(swiper);
					},
					slideChange(swiper) {
						updateSlideAria(swiper);
					},
				},
			});

			bindPauseButton(slideshow, slideshowSwiper);

			if (slideshowSwiper.slides.length < 2) {
				slideshowSwiper.allowTouchMove = false;
			} else {
				slideshowSwiper.allowTouchMove = true;
				slideshow.classList.add("slideshow__swiper--multiple-slides");
			}
		});
	};

	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();
